<template>
  <div class="main">
    <h1>Test section</h1>
    <bar-chart-component v-bind:graph_data="data"></bar-chart-component>
    <table-component v-bind:graph_data="tableData"></table-component>
    <donnut-chart-section v-bind:graph_data="donnutChartData"></donnut-chart-section>
    <table-component v-bind:graph_data="tableData2" v-bind:show_percentage_measurer="true"></table-component>
    <vertical-table-component v-bind:graph_data="tableDataHorizontal"></vertical-table-component>
    <vertical-table-component2 v-bind:graph_data="tableDataHorizontal"></vertical-table-component2>
    <special-slider v-bind:graph_data="sliderData"></special-slider>
    <table-component v-bind:graph_data="tableData3" v-bind:percentage_color="new_color_two"></table-component>
    <table-component v-bind:graph_data="tableData4"></table-component>
    <donnut-chart-section v-bind:graph_data="donnutChartData2" v-bind:uni_color="uniColor"></donnut-chart-section>
    <table-component v-bind:graph_data="tableData5" v-bind:percentage_color="new_color"></table-component>
    <table-component v-bind:graph_data="tableData6" v-bind:percentage_color="new_color_three"></table-component>
    <market-grade v-bind:graph_data="marketGrade"></market-grade>
    <table-component v-bind:graph_data="tableData7" v-bind:percentage_color="new_color_three"></table-component>
  </div>
</template>

<script>
import barChartComponent from "./BarChart";
import tableComponent from "./TableData";
import donnutChartSection from "./DonnutChartSection";
import verticalTableComponent from "./VerticalTableData";
import verticalTableComponent2 from "./VerticalTableData2";
import specialSlider from "./SpecialSlider";
import marketGrade from "./marketGrade";
export default {
  components: {
    barChartComponent: barChartComponent,
    tableComponent: tableComponent,
    donnutChartSection: donnutChartSection,
    verticalTableComponent: verticalTableComponent,
    verticalTableComponent2: verticalTableComponent2,
    specialSlider: specialSlider,
    marketGrade: marketGrade
  },
  data() {
    return {
      new_color: "red",
      new_color_two: "#001F5C",
      new_color_three: "#FFB25D",
      uniColor: {
        name: "Estructurados",
        color: "#F48073"
      },
      data: {
        tittle: "Comparativo benchmark del mercado",
        dates: ["Rto.2015", "Rto.2016", "Rto.Acum.2017", "Rto.Acum.2015-17"],
        trace1: {
          name: "Fondos RV",
          data: [-0.2, 0.14, 0.23, 0.5]
        },
        trace2: {
          name: "Benchmark",
          data: [-0.6, 0.18, 0.275589, 1]
        }
      },
      tableData: {
        titles: [
          {
            prop: "name",
            label: "Nombre"
          },
          {
            prop: "mail",
            label: "Correo electrónico"
          },
          {
            prop: "percentage",
            label: "Ejemplo Porcentage"
          }
        ],
        data: [
          {
            name: "Hector Ivan Patricio",
            mail: "hectorivan@hal.com.mx.co",
            percentage: 0.1
          },
          {
            name: "David Gonzáles",
            mail: "david@hal.com.mx.co",
            percentage: 0.10
          },
          {
            name: "Grecia de Hal",
            mail: "gracias@hal.com.mx.co",
            percentage: 0.0100
          }
        ]
      },
      donnutChartData: {
        data: [0.1, 0.2, 0.3, 0.4, 0.6],
        labels: [
          "Estructurados",
          "Deuda",
          "Capitales",
          "Fondos RF",
          "Fondos RV"
        ],
        titles: [
          {
            name: "Estructurados",
            percentage: 0.03445,
            amount: 5330.5
          },
          {
            name: "Deuda",
            percentage: 0.3254,
            amount: 3330.5
          },
          {
            name: "Capitales",
            percentage: 1,
            amount: 3330.5
          },
          {
            name: "Fondos RF",
            percentage: 0.6255,
            amount: 3330.5
          },
          {
            name: "Fondos RV",
            percentage: 0.902,
            amount: 3330.5
          }
        ]
      },
      sliderData: {
        // value: 0.1,
        items: [
          {
            percentage: 0.5,
            name: "CCC"
          },
          {
            percentage: 0.4869,
            name: "B"
          },
          {
            percentage: 0.1385,
            name: "BB"
          },
          {
            percentage: 0,
            name: "BBB"
          },
          {
            percentage: 0,
            name: "A"
          },
          {
            percentage: 0.375,
            name: "AA"
          },
          {
            percentage: 0,
            name: "AAA"
          }
        ]
      },
      tableData2: {
        titles: [
          {
            prop: "tipo",
            label: "Tipo"
          }
        ],
        data: [
          {
            tipo: "Hector Ivan Patricio",
            percentage: 0.72
          },
          {
            tipo: "David Gonzáles",
            percentage: 0.5
          },
          {
            tipo: "Grecia de Hal",
            percentage: 0.1
          }
        ],
        percentage: true
      },
      tableDataHorizontal: [
        {
          name: "Rendimientos acum. 2017",
          value: -0.151489
        },
        {
          name: "Comisiones",
          value: 0.1 // 0.551489
        }
      ],
      tableData3: {
        titles: [],
        data: [
          {
            name: "MATERIALES",
            percentage: 0.72
          },
          {
            name: "DERIVADO",
            percentage: 0.5
          },
          {
            name: "SALUD",
            percentage: 0.1
          },
          {
            name: "MATERIALES",
            percentage: 1
          },
          {
            name: "MATERIALES",
            percentage: 0.1
          }
        ],
        distributionPerSector: true
      },
      tableData4: {
        titles: [
          {
            prop: "emisora",
            label: "Emisora"
          }
        ],
        titles2: [
          {
            prop: "price",
            label: "Precio"
          },
          {
            prop: "amount",
            label: "Monto"
          }
        ],
        data: [
          {
            emisora: "BONDESD 201224",
            percentage: 0.72,
            price: 99.69,
            amount: 535582.72,
            securities: 10,
            assetType: "Tipo de emisor",
            rateType: "Tasa Variable",
            score: "EJEMPLO1",
            sliderValue: { value: 1 }
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.5,
            price: 99.69,
            amount: 535582.72,
            securities: 60,
            assetType: "Tipo de emisor",
            rateType: "Tasa Variable",
            score: "EJEMPLO2",
            sliderValue: { value: 0.112321 }
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.1,
            price: 99.69,
            amount: 12,
            securities: 20,
            assetType: "Tipo de emisor",
            rateType: "Tasa Variable",
            score: "EJEMPLO3",
            sliderValue: { value: 0.9 }
          }
        ],
        percentage: true,
        extraData: true
      },
      donnutChartData2: {
        data: [0.1987123, 0.2, 0.3, 0.11, 0.2],
        labels: [
          "Estructurados",
          "Deuda",
          "Capitales",
          "Fondos RF",
          "Fondos RV"
        ],
        titles: [
          {
            name: "Estructurados",
            percentage: 0.1987123,
            amount: 5330.99
          },
          {
            name: "Deuda",
            percentage: 0.2,
            amount: 3330.5
          },
          {
            name: "Capitales",
            percentage: 0.3,
            amount: 3330.5
          },
          {
            name: "Fondos RF",
            percentage: 0.11,
            amount: 3330.5
          },
          {
            name: "Fondos RV",
            percentage: 0.2,
            amount: 3330.5
          }
        ]
      },
      tableData5: {
        titles: [
          {
            prop: "emisora",
            label: "Emisora"
          }
        ],
        titles2: [
          {
            prop: "price",
            label: "Precio"
          },
          {
            prop: "amount",
            label: "Monto"
          }
        ],
        data: [
          {
            emisora: "BONDESD 201224",
            percentage: 0.72,
            price: 99.69,
            amount: 535582.72,
            /* Hidden Data */
            securities: 1743876,
            completeName: "Grupo Aeroportuario del sureste S.A.",
            assetType: "Acciones Domésticas",
            sector: "Industrial",
            bursatility: "NA"
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.5,
            price: 99.69,
            amount: 535582.72,
            /* Hidden Data */
            securities: 1743876,
            completeName: "Grupo Aeroportuario del sureste S.A.",
            assetType: "Acciones Domésticas",
            sector: "Industrial",
            bursatility: "SIN BURSATILIDAD"
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.1,
            price: 99.69,
            amount: 535582.72,
            /* Hidden Data */
            securities: 1743876,
            completeName: "Grupo Aeroportuario del sureste S.A.",
            assetType: "Acciones Domésticas",
            sector: "Industrial",
            bursatility: "ALTA"
          },
          {
            emisora: "BONDESD 201227",
            percentage: 0.1,
            price: 99.01,
            amount: 535542.72,
            /* Hidden Data */
            securities: 1743876,
            completeName: "Grupo Aeroportuario del sureste S.A.",
            assetType: "Acciones Domésticas",
            sector: "Industrial",
            bursatility: "MEDIA"
          }
        ],
        percentage: true,
        extraDataTwo: true
      },
      tableData6: {
        titles: [
          {
            prop: "emisora",
            label: "Emisora"
          }
        ],
        titles2: [
          {
            prop: "amount",
            label: "Monto"
          },
          {
            prop: "rtoAcom_2015_2017",
            label: "Rto Acom. 2015-2017"
          },
          {
            prop: "comisiones",
            label: "Comisiones"
          }
        ],
        data: [
          {
            emisora: "BONDESD 201224",
            percentage: 0.72,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1256,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.5,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1289,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          },
          {
            emisora: "BONDESD 201224",
            percentage: 0.1,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1256,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          }
        ],
        percentage: true,
        extraDataThree: true
      },
      marketGrade: {
        titles: [
          {
            prop: "grade",
            label: "Calificación"
          }
        ],
        titles2: [
          {
            prop: "percentage",
            label: "%"
          },
          {
            prop: "color"
          }
        ],
        data: [
          {
            grade: "mxAAA",
            percentage: 0.425477,
            color: "red"
          },
          {
            grade: "mxAA+",
            percentage: 0.45,
            color: "blue"
          },
          {
            grade: "mxAA",
            percentage: 0.12,
            color: "yellow"
          }
        ]
      },
      tableData7: {
        titles: [
          {
            prop: "emisora",
            label: "Emisora"
          },
          {
            prop: "mercado",
            label: "Mercado"
          }
        ],
        titles2: [],
        data: [
          {
            emisora: "BONDESD 201224",
            color: "green",
            mercado: "Mercado uno",
            percentage: 0.72,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1256,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          },
          {
            emisora: "BONDESD 201224",
            color: "yellow",
            mercado: "Mercado dos",
            percentage: 0.5,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1289,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          },
          {
            emisora: "BONDESD 201224",
            color: "red",
            mercado: "Mercado tres",
            percentage: 0.1,
            amount: 535582.72,
            rtoAcom_2015_2017: 0.1256,
            comisiones: 0.1256,
            /* Hidden Data */
            securities: 1743876,
            price: 8.83,
            score: "AAA",
            instrumentComposition: [
              {
                name: "instrumento1",
                inversionType: "inversionType1",
                percentage: 0.4582
              },
              {
                name: "instrumento2",
                inversionType: "inversionType2",
                percentage: 0.4582
              },
              {
                name: "instrumento3",
                inversionType: "inversionType3",
                percentage: 0.4582
              }
            ]
          }
        ],
        percentage: true,
        extraDataThree: true
      }
    };
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style lang="css">
h1 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TestSection.vue